import {RouterModule, Routes} from "@angular/router";
import {ModuleWithProviders} from "@angular/core";

export const routes: Routes = [];

export const routing: ModuleWithProviders<any> = RouterModule.forChild(routes);
